import DocumentCenter from './DocumentCenterContainer';

export default DocumentCenter;